import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem, makeCustomProp } from '@/utils';
import { useParent } from '@vant/use';
import { STEP_ITEMS_KEY } from '@/components/step-items/StepItems';
import { Cell } from 'vant';

const { name, bem } = createNamespaceBem('step-item');

const stepItemProps = {
  title: String,
  subTitle: String,
  desc: String,
  disabled: makeCustomProp<boolean>(Boolean, false),
};

export type StepItemProps = ExtractPropTypes<typeof stepItemProps>;

export default defineComponent({
  name,
  props: stepItemProps,
  setup(props) {
    const { parent, index } = useParent(STEP_ITEMS_KEY);

    if (!parent) {
      console.error('[Fda] <StepItem> 组件必须是在 <StepItems> 组件内调用！');
      return;
    }

    const parentProps = parent.props;

    const isActive = () => {
      return index.value < +parentProps.active;
    };

    const onClickStepItem = () => {
      if (props.disabled) return;
      parent.onClickStepItem(index.value);
    };

    const renderTitle = () => {
      return (
        <div class={bem('title')}>
          <div class={bem('number')}>{index.value + 1}</div>
          {props.title}
          {props.subTitle && <div class={bem('sub-title')}>{props.subTitle}</div>}
        </div>
      );
    };

    const renderDesc = () => {
      return <div class={bem('desc')}>{props.desc}</div>;
    };

    const getSlots = () => {
      if (parentProps.direction === 'horizontal') {
        return {
          title: renderTitle,
        };
      }
      return {
        title: renderTitle,
        label: renderDesc,
      };
    };

    return () => {
      return (
        <Cell
          class={bem('', {
            active: isActive(),
            vertical: parentProps.direction === 'vertical',
            horizontal: parentProps.direction === 'horizontal',
            current: index.value === +parentProps.active - 1,
          })}
          onClick={onClickStepItem}
          isLink={!(parentProps.disabled || props.disabled) && parentProps.direction === 'vertical'}
          border
          v-slots={getSlots()}
        />
      );
    };
  },
});
